import { useEffect, useState } from "react";
import { Plus, Search } from "lucide-react";
import { api } from "@/lib/api";
import { Mug, Squiggle } from "@/components/Motifs";

export default function FAQs() {
  const [faqs, setFaqs] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(0);
  useEffect(() => { api.get("/public/faqs").then((r) => setFaqs(r.data || [])); }, []);
  const filtered = faqs.filter((f) => (f.question + f.answer).toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-testid="faqs-page" className="bg-[#FFF9F0]">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-28 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5 lg:sticky lg:top-28 self-start">
          <div className="kicker text-[#FF6657] rise">FAQs</div>
          <h1 className="font-display text-6xl md:text-8xl leading-[0.85] tracking-[-0.04em] mt-4 rise d1">Questions?<br /><span className="italic text-[#3458B5]">We've got answers.</span></h1>
          <p className="font-hand text-2xl mt-6 flex items-center gap-3 rise d2">still stuck? ask the family group chat <Squiggle width={60} /></p>
          <Mug className="w-24 mt-10 -rotate-6 hidden lg:block" />
        </div>
        <div className="lg:col-span-7">
          <div className="relative mb-8">
            <Search size={18} className="absolute left-5 top-1/2 -translate-y-1/2 text-[#A62D58]" />
            <input data-testid="faq-search" placeholder="Search parking, plus-ones, outfits…" value={q} onChange={(e) => setQ(e.target.value)}
              className="w-full pl-12 pr-5 py-4 rounded-full border-2 border-[#252122] bg-[#FFF9F0] outline-none focus:ring-4 focus:ring-[#F7B733]/50" />
          </div>
          <div className="space-y-4">
            {filtered.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={f.id || i} data-testid={`faq-${i}`} className={`border-2 border-[#252122] transition-colors ${isOpen ? "bg-[#F7C9D0] shadow-[6px_6px_0_#252122]" : "bg-[#FFF9F0] hover:bg-[#FFF2DC]"}`}>
                  <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="w-full flex items-center gap-4 text-left px-5 md:px-7 py-5">
                    <span className="font-display italic text-2xl text-[#A62D58] w-9 shrink-0">{String(i + 1).padStart(2, "0")}</span>
                    <span className="font-display text-xl md:text-2xl flex-1">{f.question}</span>
                    <span className={`w-9 h-9 shrink-0 rounded-full bg-[#FF6657] border-2 border-[#252122] flex items-center justify-center transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`}><Plus size={16} /></span>
                  </button>
                  {isOpen && <p className="px-5 md:px-7 pb-6 md:pl-[4.75rem] text-lg leading-relaxed page-enter">{f.answer}</p>}
                </div>
              );
            })}
            {filtered.length === 0 && <div className="py-12 text-center font-hand text-2xl text-[#252122]/60" data-testid="faq-empty">Nothing matches that. Try another word?</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
